import Axios from "axios";

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export function postBookingData(params) {
    return Axios.post(`${API_HOST}/bookings`, params);
}